<template>
  <div
    v-if="!loading"
    class="block-form"
  >
    <a
      v-b-toggle="`collapseBlock-${index}${option.type}`"
      :class="`btn btn-sm btn-${option.relations && option.relations.length ? 'success' : 'dark' } dis-ib`"
    >
      <i data-feather="corner-left-up" /> {{ option.relations && option.relations.length ? 'With' : 'Add' }} relationship
    </a>
    <b-collapse :id="`collapseBlock-${index}${option.type}`">
      <div class="mt-3">
        <div class="card shadow-none bg-transparent border-secondary">
          <div class="card-body">
            <h3>Add relationship</h3>
            <div
              v-for="(relation, index) in option.relations"
              :key="index"
              class="row d-flex align-items-end"
            >
              <div class="col-sm-6">
                <div class="mb-1">
                  <label
                    for="formFile"
                    class="form-label"
                  >Select form element</label>
                  <v-select
                    v-model="relation.block"
                    label="title"
                    :options="selects"
                    :get-option-key="option => option.title"
                    @input="relation.options = null"
                  />
                </div>
              </div>
              <div class="col-sm-5">
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Condition</label>
                  <v-select
                    v-model="relation.options"
                    multiple
                    label="option"
                    :options="getOptions(relation)"
                    :get-option-key="option => option.option"
                  />
                </div>
              </div>
              <div class="col-sm-1">
                <div class="mb-1">
                  <a
                    class="btn bg-light-danger"
                    @click="removeRelation(index)"
                  ><i data-feather="trash-2" /></a>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-dark"
              @click="addRelation"
            >
              <i data-feather="plus" /> Add relationship
            </button>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCollapse } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
  },
  props: {
    option: { type: Object, required: true },
    block: { type: Object, required: true },
    index: { type: [String, Number], required: true },
  },
  data() {
    return {
      selectedOne: [],
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      form: 'requestForms/item',
    }),
    selects() {
      return this.form.new_blocks.filter(e => e.type.toLowerCase() === 'several_options' && e.id !== this.block.id)
    },
  },
  mounted() {
    this.loading = false
  },
  methods: {
    getOptions(relation) {
      return relation.block && relation.block.options ? JSON.parse(JSON.stringify(relation.block.options)) : []
    },
    addRelation() {
      this.option.relations.push({
        block: null,
        options: [],
      })
    },
    removeRelation(index) {
      this.option.relations.splice(index, 1)
    },
  },
}
</script>
